import React, {Component, useState} from 'react';
import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {FormControl, Grid} from "@mui/material";
import RaikoMaterialOutlinedPasswordInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedPasswordInput";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import RaikoGridThreeColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridThreeColumn";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";

const ChangePasswordCardComponent = (
    {
        service,
        adminId = -1
    }) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()


    const [lastPassword, setLastPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [repeatNewPassword, setRepeatNewPassword] = useState("");

    function doChangePassword() {
        if (checkFields()) {
            loading(setLoadingStateDispatch(true))
            if (adminId === -1 ){
                updateAdminPassword()
            }else {
                updateManagerPassword()
            }
        }
    }

    function updateManagerPassword() {
        service.changeManagerPasswordById(adminId, newPassword)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "رمز عبور با موفقیت بروزرسانی شد."))
                clearFields()
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بروزرسانی رمز عبور!"))
        })
    }

    function updateAdminPassword() {
        service.changePassword(lastPassword, newPassword)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "رمز عبور با موفقیت بروزرسانی شد."))
                clearFields()
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بروزرسانی رمز عبور!"))
        })
    }

    function clearFields() {
        setLastPassword("")
        setNewPassword("")
        setRepeatNewPassword("")
    }

    function checkFields() {
        let message = ""
        let state = true

        if (lastPassword.length < 8 && adminId === -1) {
            state = false
            message = "لطفا رمز عبور قبلی خود را به درستی وارد نمایید!"
        } else if (newPassword.length < 8) {
            state = false
            message = "رمز عبور جدید حداقل باید 8 کاراکتر باشد!"
        } else if (newPassword !== repeatNewPassword) {
            state = false
            message = "تکرار رمز عبور با رمز عبور جدید مطابقت ندارد!"
        }

        if (message.length > 0)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))

        return state
    }

    return (<section
        className={`default-card-container-background-style  ${css`
          padding: 16px;
          margin-top: 16px;
          display: flex;
          flex-direction: column;
        `}`}
    >
                    <span
                        className={css`
                          font-size: var(--text-size-large);
                          width: 100%;
                          flex-shrink: 0;
                          color: var(--color-text);
                        `}>
                        تغییر رمز عبور
                    </span>

        <Alert severity="warning" className={css`margin-top: 16px;`}>
            <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
            <div className={css`display: flex;
              flex-direction: column;
              gap: 8px;
              margin-top: 16px;
            `}>
                <span>رمز عبور حداقل باید <strong> 8 کاراکتر</strong> باشد.</span>
                <span>برای داشتن رمزی قوی تر از <strong>حروف بزرگ و کوچک، کاراکتر ها و اعداد</strong> با یکدیگر استفاده نمایید.</span>
            </div>
        </Alert>

        {adminId === -1 &&
            <RaikoGridThreeColumn className={css`margin-top: 1rem;`}>
                <FormControl fullWidth>
                    <RaikoMaterialOutlinedPasswordInput
                        labelText={"رمز عبور قبلی"}
                        spellCheck={false}
                        value={lastPassword}
                        onChange={e => {
                            setLastPassword(e.target.value)
                        }}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <RaikoMaterialOutlinedPasswordInput
                        labelText={"رمز عبور جدید"}
                        spellCheck={false}
                        value={newPassword}
                        onChange={e => {
                            setNewPassword(e.target.value)
                        }}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <RaikoMaterialOutlinedPasswordInput
                        labelText={"تکرار رمز عبور جدید"}
                        spellCheck={false}
                        value={repeatNewPassword}
                        onChange={e => {
                            setRepeatNewPassword(e.target.value)
                        }}
                    />
                </FormControl>

            </RaikoGridThreeColumn>
        }

        {adminId !== -1 &&
            <RaikoGridTwoColumn className={css`margin-top: 1rem;`}>
                <FormControl fullWidth>
                    <RaikoMaterialOutlinedPasswordInput
                        labelText={"رمز عبور جدید"}
                        spellCheck={false}
                        value={newPassword}
                        onChange={e => {
                            setNewPassword(e.target.value)
                        }}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <RaikoMaterialOutlinedPasswordInput
                        labelText={"تکرار رمز عبور جدید"}
                        spellCheck={false}
                        value={repeatNewPassword}
                        onChange={e => {
                            setRepeatNewPassword(e.target.value)
                        }}
                    />
                </FormControl>

            </RaikoGridTwoColumn>
        }

        <div className={css`margin-top: 16px;
          display: flex;
          justify-content: left;`}>
            <ButtonPrimaryRaiko
                label={"تغییر رمز عبور"}
                onClick={doChangePassword}
            />
        </div>
    </section>)
}

export default ChangePasswordCardComponent